import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
//import Query from "./pages/layout/Query/QueryBuilder";
import QueryBuilder from "./pages/layout/Query/QueryBuilder";

import { getTheme } from "./redux/themeSlice";
import { useDispatch, useSelector } from "react-redux";
import { ThemeProvider, css, Global } from "@emotion/react";
import Dashboard from "./pages/dashboard/Marketing";
import SavedQueries from "./pages/savedQueries/SavedQueries";
import Notfound from "./pages/layout/Notfound";
import { Notification } from "./components/Notification";
import { SavedQueriesList } from "./pages/savedQueries/SavedQueriesList";
import Admin from "./pages/layout/Admin/Admin";
import Home from "./pages/layout/Landing/Home";
import { AccessDenied } from "./pages/AccessDenied";
import { ServerIssue } from "./pages/ServerIssue";
import { AppDispatch, RootState } from "./redux/store";
import { fetchUser } from "./redux/userSlice";
import Loading from "./components/Loading";

export default function App() {
  const theme = useSelector(getTheme);
  const dispatch = useDispatch<AppDispatch>();
  const { user: currentUser, loading: userLoading, loaded: userLoaded } =
    useSelector((state: RootState) => state.user);
  const appTheme = theme;

  //Add tooltips to AG Grid filter items
  useEffect(() => {
    const addTooltipsToFilterItems = () => {
      const labels = document.querySelectorAll(".ag-set-filter-item .ag-label");
      labels.forEach((label: Element) => {
        const htmlLabel = label as HTMLElement;
        if (!htmlLabel.hasAttribute("title") && htmlLabel.textContent) {
          htmlLabel.setAttribute("title", htmlLabel.textContent.trim());
        }
      });
    };

    // Use MutationObserver to detect when filter popup opens
    const observer = new MutationObserver(() => {
      addTooltipsToFilterItems();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (userLoading || userLoaded) {
      return;
    }

    dispatch(fetchUser());
  }, [dispatch, userLoading, userLoaded]);

  const isAdmin = currentUser.features.includes("Admin");
  const adminRouteElement = !userLoaded ? (
    <Loading show={true} />
  ) : isAdmin ? (
    <Admin />
  ) : (
    <AccessDenied />
  );

  return (
    <ThemeProvider theme={appTheme}>
      <Notification />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />}></Route>
          <Route path="/home" element={<Home />}></Route>
          <Route path="/analysis/query" element={<QueryBuilder />}></Route>
          <Route
            path="/analysis/savedqueries"
            element={<SavedQueries />}
          ></Route>
          <Route
            path="/analysis/savedqueries/querylist"
            element={<SavedQueriesList />}
          ></Route>
          <Route path="/analysis" element={<QueryBuilder />}></Route>
          {/* <Route path="/prospecting" element={<Dashboard />}></Route>
          <Route path="/prospecting/findfleet" element={<Dashboard />}></Route> */}
          <Route path="/admin" element={adminRouteElement}></Route>
          <Route path="/auth/logoutPage" element={<AccessDenied />}></Route>
          <Route path="/networkissue" element={<ServerIssue />}></Route>

          <Route path="*" element={<Notfound children={undefined} />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
